export const SET_DAMAGE_DATA = "SET_DAMAGE_DATA";
